// extracted by mini-css-extract-plugin
export default {"circle":"zep52","is-selected":"b4W3u"};